import type { MouseEvent } from 'react'

/**
 * Clicking empty space on a table row opens the first-column name link/button.
 * Ignores clicks on real controls (links, buttons, action icons, inputs).
 */
export function onClickableTableRow(e: MouseEvent<HTMLTableRowElement>) {
  const target = e.target as HTMLElement
  if (
    target.closest(
      'a, button, input, select, textarea, label, .incyia-row-actions, .detail-row-actions, .MuiSwitch-root, .incyia-pill, .entity-selector, .react-select__control, .react-select__menu'
    )
  ) {
    return
  }

  const opener = e.currentTarget.querySelector(
    'a.incyia-name-link, button.incyia-name-link, button.incyia-family-label, a.incyia-family-label'
  ) as HTMLElement | null

  opener?.click()
}
